import { render, staticRenderFns } from "./Sweden.vue?vue&type=template&id=6aa8b535&"
import script from "./Sweden.vue?vue&type=script&lang=js&"
export * from "./Sweden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa8b535')) {
      api.createRecord('6aa8b535', component.options)
    } else {
      api.reload('6aa8b535', component.options)
    }
    module.hot.accept("./Sweden.vue?vue&type=template&id=6aa8b535&", function () {
      api.rerender('6aa8b535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Sweden.vue"
export default component.exports